import { FC, useMemo } from "react";
// 组件
import { ProTable } from '../../../antd';
// 常量
import { LeftTableProps } from "../../interface";

const LeftTable: FC<LeftTableProps> = props => {
  const { dataSource, columns: outColumns, rowKey, width, height, rowSelection, onRow, } = props;
  /** 列配置 */
  const columns = useMemo(() => {
    return outColumns?.map(item => {
      return {
        ...item,
        ellipsis: true,
      };
    });
  }, [outColumns]);
  return (
    <ProTable
      size="small"
      rowKey={rowKey}
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      rowSelection={rowSelection}
      onRow={onRow}
      scroll={{
        x: width ? width : 'max-content',
        y: height,
      }}
    />
  );
};

export default LeftTable;
